<common-toolbar [logo]="themeLogoUrl$" maxContentWidth="968px"></common-toolbar>

<div class="page-container">
  <div class="sign-up-screen-container">
    <div class="form-area">
      <mat-card class="mat-card-design" >
        <mat-card-header class="justify-between" *ngIf="overview$ | async as overview">
          <mat-card-title class="font-source py-2">{{'property' | translate}}:
              <span>{{overview.property?.address | address}}</span>
          </mat-card-title>
          <mat-card-subtitle *ngIf="overview.property?.address?.stairway">{{'stairway' | translate}} {{overview.property?.address?.stairway}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="overview.property?.address?.doorNumber">{{'door_number' | translate}} {{overview.property?.address?.doorNumber}}</mat-card-subtitle>
          <mat-card-subtitle class="font-source subtitle-padding">{{'offer_details.new_offer_hint' | translate}}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="py-4">
            <customer-form [formGroup]="customerForm"></customer-form>
          </div>
        </mat-card-content>
        <mat-card-actions align="end">
          <mat-spinner *ngIf="loading" [diameter]="20" class="mr-2"></mat-spinner>
          <button mat-flat-button color="primary" class="text-primary" (click)="openOffer()"
            [disabled]="loading">{{'general.continue' | translate}}</button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div class="agent-area" *ngIf="overview$ | async as overview">
      <property-overview-agent [agent]="agent" [property]="overview.property"></property-overview-agent>
    </div>
  </div>
</div>